export default {
  'otp.oldPrice': '原價 ',
  'otp.details': '限時免費活動詳情',
  'otp.effective': '有效時間',
  'otp.userTitle': '優惠用戶',
  'otp.tip': '如果您已購買其他EngageLab產品，但未充值OTP，您仍可參與本次活動',
  'otp.service.dsc': '首次購買OTP產品的用戶',
  'otp.event': '活動',
  'otp.tip1a': '在促銷期間，首次充值OTP的用戶將從充值之日起',
  'otp.tip1b': '30自然日內',
  'otp.tip1c': '免除OTP驗證費。',
  'otp.notes1': '1. 本活動每個帳戶僅可參與一次。',
  'otp.notes2': '2. 一旦充值完成，將不再提供退款。如需進一步幫助，請',
  'otp.notes2a': '聯繫我們',
  'otp.notes2b': '了解詳情。',
  'otp.notes3': '3. EngageLab 保留對活動的最終法律解釋權。',
  'email.sem.title': '限時福利！新用戶專享每日500封免費郵件。',
  'email.sem.btn': '立即開始',
};
